import { SignalRService } from "@kuva/ui-helpers";

export const signalRServiceInstance = SignalRService.Instance(
  `${process.env.REACT_APP_KUVA_API_URL}/signalr/v1`
);
